var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewMore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21967 3.96967C5.51256 3.67678 5.98744 3.67678 6.28033 3.96967L9.5 7.18934L12.7197 3.96967C13.0126 3.67678 13.4874 3.67678 13.7803 3.96967C14.0732 4.26256 14.0732 4.73744 13.7803 5.03033L10.0303 8.78033C9.73744 9.07322 9.26256 9.07322 8.96967 8.78033L5.21967 5.03033C4.92678 4.73744 4.92678 4.26256 5.21967 3.96967ZM5.21967 9.21967C5.51256 8.92678 5.98744 8.92678 6.28033 9.21967L9.5 12.4393L12.7197 9.21967C13.0126 8.92678 13.4874 8.92678 13.7803 9.21967C14.0732 9.51256 14.0732 9.98744 13.7803 10.2803L10.0303 14.0303C9.73744 14.3232 9.26256 14.3232 8.96967 14.0303L5.21967 10.2803C4.92678 9.98744 4.92678 9.51256 5.21967 9.21967Z",
    fill: "#017C57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewMore);
export default __webpack_public_path__ + "static/media/viewMore.8f91909fd8d4118215f2d191ae265a23.svg";
export { ForwardRef as ReactComponent };